module.exports = __webpack_public_path__ + "static/media/18ECA2.0c7d2e09.jpg";